/**
 * Validación de fortaleza de contraseña — fuente de verdad frontend.
 * Las reglas son IDÉNTICAS a las del backend: Util.validatePasswordStrength()
 *   - Mínimo 8 caracteres
 *   - Al menos una letra mayúscula [A-Z]
 *   - Al menos una letra minúscula [a-z]
 *   - Al menos un número [0-9]
 *
 * IMPORTANTE: si se cambian las reglas aquí, hay que cambiarlas también en
 * backend/Cuberite/src/main/java/com/cubiclan/cuberite/util/Util.java
 */

/**
 * Valida la fortaleza de una contraseña.
 * @param {string} password
 * @returns {string} Mensaje de error, o cadena vacía si la contraseña es válida.
 */
export function validatePasswordStrength(password) {
  if (!password || password.length < 8)
    return "La contraseña debe tener al menos 8 caracteres";
  if (!/[A-Z]/.test(password))
    return "La contraseña debe contener al menos una letra mayúscula";
  if (!/[a-z]/.test(password))
    return "La contraseña debe contener al menos una letra minúscula";
  if (!/\d/.test(password))
    return "La contraseña debe contener al menos un número";
  return "";
}
